
import { supabase } from "@/integrations/supabase/client";
import type { DocumentWithRelations } from './documentTypes';

export const fetchDocumentsByOrganization = async (organizationId: string): Promise<DocumentWithRelations[]> => {
  try {
    const { data, error } = await supabase
      .from('documents')
      .select(`
        *,
        organization:organization_id (
          id, name
        ),
        contact:contact_id (
          id, first_name, last_name, email
        )
      `)
      .eq('organization_id', organizationId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    
    return data as DocumentWithRelations[];
  } catch (error) {
    throw error;
  }
};

export const fetchDocumentsByContact = async (contactId: string): Promise<DocumentWithRelations[]> => {
  try {
    const { data, error } = await supabase
      .from('documents')
      .select(`
        *,
        organization:organization_id (
          id, name
        ),
        contact:contact_id (
          id, first_name, last_name, email
        )
      `)
      .eq('contact_id', contactId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    
    return data as DocumentWithRelations[];
  } catch (error) {
    throw error;
  }
};

export const fetchDocumentsByOpportunity = async (opportunityId: string): Promise<DocumentWithRelations[]> => {
  try {
    const { data, error } = await supabase
      .from('documents')
      .select(`
        *,
        organization:organization_id (
          id, name
        )
      `)
      .eq('opportunity_id', opportunityId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    
    return data as DocumentWithRelations[];
  } catch (error) {
    throw error;
  }
};
